/**
 * Equipo consume Comisiones vía public-api (ADR-030).
 * No actualizar employees.earns_commission / commission_plan_id directo.
 */
import {
  assignEmployeeToPlan,
  setEmployeeEarnsCommission,
  unassignEmployeeFromPlan,
} from '../../commissions/public-api';

function mapCommissionConfigError(raw: string | undefined, fallback: string): string {
  const msg = (raw ?? '').trim();
  if (!msg) return fallback;
  if (/not_authenticated/i.test(msg)) return 'Sesión requerida. Volvé a iniciar sesión.';
  if (/Sin organización|organization/i.test(msg)) return 'No encontramos el negocio de esta sesión.';
  if (/employee_user_required/i.test(msg)) return 'No encontramos a esa persona.';
  if (/^(PGRST|JWT|duplicate key|violates|permission denied)/i.test(msg)) return fallback;
  if (msg.length <= 160 && (/[áéíóúñ]/i.test(msg) || /\b(no |la |el )/i.test(msg))) return msg;
  return fallback;
}

/**
 * Actualiza config de comisiones del empleado usando RPCs owner (Comisiones).
 * @param authUserId employees.auth_user_id (no el id de fila employees)
 */
export async function updateEmployeeCommissionSettings(
  authUserId: string,
  params: {
    earnsCommission?: boolean;
    commissionPlanId?: string | null;
    /** Plan actual (para unassign al limpiar). */
    currentPlanId?: string | null;
  }
): Promise<void> {
  const fallback = 'No se pudo actualizar la configuración de comisiones.';
  if (!authUserId) throw new Error('No encontramos a esa persona.');

  try {
    if (params.earnsCommission === false) {
      await setEmployeeEarnsCommission(authUserId, false);
      return;
    }

    if (params.commissionPlanId) {
      await assignEmployeeToPlan({
        planId: params.commissionPlanId,
        employeeUserId: authUserId,
        organizationId: '',
      });
      return;
    }

    if (params.commissionPlanId === null) {
      const current = params.currentPlanId;
      if (current) {
        await unassignEmployeeFromPlan(current, authUserId);
      }
      return;
    }

    if (params.earnsCommission === true) {
      await setEmployeeEarnsCommission(authUserId, true);
    }
  } catch (e: unknown) {
    const raw = e instanceof Error ? e.message : undefined;
    throw new Error(mapCommissionConfigError(raw, fallback));
  }
}
